<template>
  <div class="new_home_index">
    <div class="home_header">
      <Swipe
        :loop="false"
        :show-indicators="false"
        width="100%"
        height="100%"
        :touchable="false"
        ref="swipeItem"
      >
        <SwipeItem v-for="(item,index) in tabs" :key="index">
          <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
            <template v-slot:loading>
              <loading type="spinner" size="20" />
            </template>
            <template v-slot:error>加载失败</template>
          </VanImage>
        </SwipeItem>
      </Swipe>
    </div>
    <div class="home_body">
        <!-- <div class="fuli" @click="goshop">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220608/1654655022/77791.png" alt="">
        </div> -->
        <template v-if="tabs.length">
            <div class="cent">
                <div class="tabs">
                    <div v-for="(item,index) in tabs" :key="item.id" class="tabcard" :class="{active:index===swiperIndex}" @click="switchTab(item.id,index)">
                        <img :src="index===swiperIndex?item.active:item.noactive" alt="">
                    </div>
                </div>
            </div>
            
            <SportItem
                v-if="currentItem.id==this.$route.params.item_id"
                :item="currentItem"
                :sports_id="sport_id"
                :detail="detail"
            ></SportItem>
            
        </template>
        <template v-else>
            <div class="tabbody">
                <!-- 暂无数据 -->
            </div>
        </template>
    </div>
    <div class="fl" @click="gocert">
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220909/1662698192/821191.png"/>
    </div>     
    <!-- <div class="fl" @click="goqus">
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220809/1660024477/27298.png"/>
    </div>     
    <div class="fl f" @click="goqus1">
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220809/1660024477/154204.png"/>
    </div>      -->
  </div>
</template>
<script>
    import "./index.less"
    import SportItem from "./item";
    import { Image, Loading, Tab, Tabs, Swipe, SwipeItem } from "vant";
    export default {
        name: 'homeIndex',
        data () {
            return {
                currentItem: {},
                tabs: [],
                detail: "",
                swiperIndex: 0,
                item_id: this.$route.params.item_id,
                sport_id: this.$route.params.id
            }
        },
        components:{
            VanImage: Image,
            Loading,
            Tab,
            Tabs,
            Swipe,
            SportItem,
            SwipeItem,
        },
        watch: {
            item_id(e) {
                this.itemChange();
            },
        },
        methods: {
            goshop() {
                window.location.href = 'welfare.movecloud.cn'
                // this.$toast.success('暂未开通，请耐心等待')
            },
            gocert() {
                window.location.href = 'https://frontend.moveclub.vip/score/#/a-cert?matchid=9941'
                // this.$toast.success('暂未开通，请耐心等待')
            },
            goqus() {
                this.$router.push({ name: 'luckdraw', params: { acid: 1086 }})
            },
            goqus1() {
                this.$router.push({ name: 'luckdraw', params: { acid: 1088 }})
            },
            switchTab: function (id,index) {
                this.swiperIndex = index;
                this.currentItem = this.tabs[index];
                this.$router.replace({params: {item_id: id}})
                this.$refs.swipeItem.swipeTo(index);
            },
            initIndex(){
               this.$api.wechat.jsapiConfig().then((res)=>{
               })
            },
            itemChange: function () {
                if(this.cf.isEmpty(this.item_id)){
                    this.item_id = this.tabs[0]['id']
                    this.$router.replace({params:{item_id: this.tabs[0]['id']}})
                    return ;
                }
                this.currentItem = this.tabs.filter((item) => {
                    return +item.id === +this.item_id;
                })[0];
                
            },
            init: function () {
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                });
                this.$api.sports.sportsMain(this.sport_id).then(
                    (res) => {
                    res.data.items.forEach((item,index)=>{
                        let arr = JSON.parse(item.content)
                        item.active = arr[0]
                        item.noactive = arr[1]
                    })
                    
                    this.tabs = res.data.items;
                    this.swiperIndex = this.tabs.findIndex((res)=>res.id ==  +this.item_id)
                    let {
                        bgstyle,
                        id,
                        tabstyle,
                        introstyle,
                        shareconfig,
                        title,
                    } = res.data;
                    try {
                        bgstyle = JSON.parse(bgstyle);
                        tabstyle = JSON.parse(tabstyle);
                        introstyle = JSON.parse(introstyle);
                        // shareconfig = JSON.parse(shareconfig);
                    } catch (e) {
                        console.error(e);
                    }
                    this.detail = { id, bgstyle, tabstyle, introstyle, title };
                    //定义 颜色
                    // this.setBgColor(bgstyle.background);
                    // this.$storage.set("shareInfo", shareconfig);
                    this.$toast.clear();
                    this.itemChange();
                    this.$refs.swipeItem.swipeTo(this.swiperIndex);
                    if (window.__wxjs_is_wkwebview) {
                        //部分ios
                        window.scrollTo(0, 1);
                    }               
                    },
                    (e) => {
                    this.$toast.clear();
                    }
                );
            },
        },     
        mounted() {
            this.$nextTick(() => {
                // this.initIndex();
                this.init()
            })

        }
    }
</script>

